import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { subtitle1 } from '../../../consts/Site'

export const LoadingScreen = () => (
  <Box textAlign="center" style={{ maxWidth: '500px', margin: '0 auto' }}>
    <img src="/images/ogp.jpg" alt="logoimage" width="100%" />
    <Typography variant="h3" gutterBottom>
      Now loading...
    </Typography>
    <Typography variant="h5" gutterBottom>
      Please wait a few seconds <br />
      until the loading of the content is completed.
    </Typography>
    <Box paddingTop={2}>
      <Typography variant="body2" gutterBottom>
        {subtitle1}
      </Typography>
    </Box>
    <Box paddingTop={2}>
      <Typography variant="body2" gutterBottom>
        Recommended browser:
        <br />
        Google Chrome(PC)
      </Typography>
    </Box>
  </Box>
)
